var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightPrimary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 7.71875L9.1875 12.7188C8.8125 13.125 8.15625 13.125 7.78125 12.7188C7.375 12.3438 7.375 11.6875 7.78125 11.3125L11.0625 8H1.5C0.9375 8 0.5 7.5625 0.5 7C0.5 6.46875 0.9375 6 1.5 6H11.0625L7.78125 2.71875C7.375 2.34375 7.375 1.6875 7.78125 1.3125C8.15625 0.90625 8.8125 0.90625 9.1875 1.3125L14.1875 6.3125C14.5938 6.6875 14.5938 7.34375 14.1875 7.71875Z",
    fill: "#6F5C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightPrimary);
export default __webpack_public_path__ + "static/media/arrow-right-primary.58cd3f63dd0387d4de2c8b18efe316e6.svg";
export { ForwardRef as ReactComponent };